import { render } from "./OTPFlow.vue?vue&type=template&id=47e11ddb"
import script from "./OTPFlow.vue?vue&type=script&lang=js"
export * from "./OTPFlow.vue?vue&type=script&lang=js"

import "./OTPFlow.vue?vue&type=style&index=0&id=47e11ddb&lang=css"

import exportComponent from "/var/www/zaytoon-zain-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__